<template>
  <a-modal
    title="选择商品"
    :width="1000"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <!-- 查询条件 -->
      <a-form layout="inline" style="margin-bottom: 16px">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="商品名称">
              <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span>
              <a-button type="primary" @click="handleQuery">
                <a-icon type="search" />查询
              </a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">
                <a-icon type="redo" />重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <!-- 商品列表 -->
      <a-table
        :loading="tableLoading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'radio'
        }"
        @change="handleTableChange"
        size="middle"
      >
        <span slot="goodsName" slot-scope="text, record">
          <a-tag v-if="record.skuName" color="orange">{{ record.skuName }}</a-tag>
        </span>
        <span slot="stock" slot-scope="text">
          <a-tag :color="text > 0 ? 'green' : 'red'">{{ text }}</a-tag>
        </span>
      </a-table>

      <!-- 底部按钮 -->
      <div style="margin-top: 16px; text-align: right">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="handleOk" style="margin-left: 8px" :disabled="!selectedRow">
          确定
        </a-button>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { getMerchantInventoryList } from '@/api/retail/inventory'
import moment from 'moment'

export default {
  name: 'InventorySelect',
  props: {
    // 供应商ID,用于筛选商品
    supplierId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      tableLoading: false,
      list: [],
      selectedRowKeys: [],
      selectedRow: null,
      queryParam: {
        goodsName: undefined,
        supplierId: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '商品ID',
          dataIndex: 'goodsId',
          width: 100,
          align: 'center'
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'skuName' }
        },
        {
          title: '采购价',
          dataIndex: 'purchasePrice',
          width: 100,
          align: 'center',
          customRender: text => text ? '¥' + parseFloat(text).toFixed(2) : '¥0.00'
        },
        {
          title: '库存数量',
          dataIndex: 'stock',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'stock' }
        },
        {
          title: '预警库存',
          dataIndex: 'alarmStock',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    show(supplierId) {
      this.visible = true
      this.selectedRowKeys = []
      this.selectedRow = null
      this.queryParam.supplierId = supplierId || this.supplierId
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      getMerchantInventoryList(params).then(response => {
        if (response.data) {
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else if (Array.isArray(response)) {
          this.list = response
          this.pagination.total = response.length
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        goodsName: undefined,
        supplierId: this.queryParam.supplierId
      }
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      if (selectedRows.length > 0) {
        this.selectedRow = selectedRows[0]
      } else {
        this.selectedRow = null
      }
    },
    handleOk() {
      if (!this.selectedRow) {
        this.$message.warning('请选择商品')
        return
      }
      this.$emit('ok', this.selectedRow)
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
